import { useMemo } from "react";
import { Link, useRouteContext } from "@tanstack/react-router";
import {
  ColoredCardInfo,
  ColoredCardInfoButton,
  ColoredCardInfoDescription,
  ColoredCardInfoHeader,
  ColoredCardInfoTitle,
} from "@/components/colored-card-info";

export const HomeSectionAssistEmptyState = (): JSX.Element => {
  const { flags } = useRouteContext({
    strict: false,
  });

  const variationTestFlagValue = useMemo(
    () => flags["grupo-teste-ab-livance-assist-home"],
    [flags],
  );

  const EmptyStates = {
    A: {
      title: "Mais dados, mais controle",
      description:
        "Com o Pro, você acessa relatórios de contatos, agendamentos e muito mais.",
      buttonLabel: "Experimentar grátis",
      id: "assist-pro-empty-state-card-a",
    },
    B: {
      title: "Um mês grátis de Assist Pro",
      description: "Ative agora e teste todos os recursos avançados sem pagar nada.",
      buttonLabel: "Experimentar agora :)",
      id: "assist-pro-empty-state-card-b",
    },
    C: {
      title: "Ainda não é Pro?",
      description:
        "Com o Assist Pro, você personaliza atendimentos, recupera agendamentos e cria lembretes com facilidade. Teste agora mesmo.",
      buttonLabel: "Experimentar agora :)",
      id: "assist-pro-empty-state-card-c",
    },
  };

  const variant = EmptyStates[variationTestFlagValue as keyof typeof EmptyStates];

  return (
    <Link to="/settings/assist" id={variant.id}>
      <ColoredCardInfo className="bg-secondary-100">
        <ColoredCardInfoHeader>
          <ColoredCardInfoTitle className="text-secondary-600">
            {variant.title}
          </ColoredCardInfoTitle>
          <ColoredCardInfoDescription className="text-secondary-600">
            {variant.description}
          </ColoredCardInfoDescription>
        </ColoredCardInfoHeader>
        <ColoredCardInfoButton className="bg-secondary-400 text-white">
          {variant.buttonLabel}
        </ColoredCardInfoButton>
      </ColoredCardInfo>
    </Link>
  );
};
